<template>
  <div class="flex mb-4">
    <div class="lg:w-2/3 w-full bg-grid-color h-12">
      <vs-card class="px-5 py-5">
        <!--
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Name</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" v-model="form.name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Password</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" type="password" v-model="form.password" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Is Active</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-switch v-model="form.is_active" />
          </div>
        </div>
        -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Email</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-input class="w-full" type="email" v-model="form.email" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/3 w-full">
            <span>Role</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <select class="form-control" v-model="form.role">
              <option v-for="(role, index) in roleOptions" :value="role" :key="index">{{role}}</option>
            </select>
          </div>
        </div>
        <div class="vx-row pt-5">
          <div class="vx-col sm:w-2/3 w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submit">Invite</vs-button>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
/*
 form: {
      name: "",
      email: "",
      password: "",
      repassword: "",
      role: "staff",
      is_active: true
    },
    */
import Service from "../../../services";
export default {
  components: {},
  data: () => ({
    form: {
      email: "",
      role: "staff"
    },
    roleOptions: ["admin", "staff", "marketing", "accountant", "check-in-staff"]
  }),
  methods: {
    submit() {
      let data = {
        e: this.$route.query.e
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.User.invite(this.form, params)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });
            this.$router.push("/users");
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
        });
    }
  }
};
</script>